import React,{useContext} from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router';
import { SoundContext } from './SoundContext';
import usePlaySound from './hooks/usePlaySound';

export default function SoundButtonPlayer({children,href, onClick, ...props}){
    const {isSoundOn} = useContext(SoundContext);
    const playPageSound = usePlaySound('/audio/484909__spacejoe__fast-page-turn-3.wav');
    const nav=useNavigate();
    const handleClick=async (e)=>{
        if(isSoundOn){
            playPageSound();
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        if(href){
            e.preventDefault();
            setTimeout(()=>{
                nav(href);
            },100);
        }
        if(onClick){
            onClick(e);
        }
    }

    return(
        <Button {...props}
            onClick={handleClick}
            href={href ? undefined : props.href}
        >
            {children}
        </Button>
    );
}